import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faClose } from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
  const [navbar, setnavbar] = useState(false);
  console.log(navbar);
  return (
    <nav className="text-lg flex flex-col h-20 w-full z-50 text-white bg-cyan-500  justify-between py-4 px-6 md:px-12">
      <div className="flex justify-between items-center">
        <div className="bg-grey-800">
          <Link to={"/"} className="">
            {/* <image /> */}
            <img
              src="https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/logo.png"
              alt="LOGO"
            />
          </Link>
        </div>
        <div className="hidden md:block w-auto">
          <div className="flex flex-row items-center ">
            <NavLink
              to={"/"}
              className={({ isActive }) =>
                isActive
                  ? "border-t-2 mx-6 hover:text-gray-200"
                  : " mx-6 hover:text-gray-200"
              }
            >
              Home
            </NavLink>
            <NavLink
              to={"/about"}
              className={({ isActive }) =>
                isActive
                  ? "border-t-2 mx-6 hover:text-gray-200"
                  : " mx-6 hover:text-gray-200"
              }
            >
              About
            </NavLink>
            <NavLink
              to={"/deals"}
              className={({ isActive }) =>
                isActive
                  ? "border-t-2 mx-6 hover:text-gray-200"
                  : " mx-6 hover:text-gray-200"
              }
            >
              Deals
            </NavLink>
            <NavLink
              to={"/reservation"}
              className={({ isActive }) =>
                isActive
                  ? "border-t-2 mx-6 hover:text-gray-200"
                  : " mx-6 hover:text-gray-200"
              }
            >
              Reservation
            </NavLink>
            <NavLink
              to={"/book-yours"}
              className={({ isActive }) =>
                isActive
                  ? "border-t-2 mx-6 hover:text-gray-200"
                  : " mx-6 hover:text-gray-200"
              }
            >
              Book Yours
            </NavLink>
          </div>
        </div>
        <div className="block text-white md:hidden">
          <button
            className="flex justify-end"
            onClick={() => {
              navbar ? setnavbar(false) : setnavbar(true);
            }}
          >
            {navbar ? (
              <FontAwesomeIcon
                icon={faClose}
                className="text-gray-200 text-4xl"
              />
            ) : (
              <FontAwesomeIcon
                icon={faBars}
                className="text-gray-200 text-4xl"
              />
            )}
          </button>
        </div>
      </div>
      <div className={`${navbar ? "z-40 block md:hidden" : "hidden"}`}>
        <div
          id="menu"
          className="bg-white mt-5 transition-all duration-1000 ease-linear text-gray-800 flex flex-col items-center "
        >
          <NavLink
            to={"/"}
            className={({ isActive }) =>
              isActive
                ? "border-t-2 py-3  text-cyan-500 mx-6 "
                : " mx-6 py-3  hover:text-cyan-500"
            }
          >
            Home
          </NavLink>
          <NavLink
            to={"/about"}
            className={({ isActive }) =>
              isActive
                ? "border-t-2 py-3  text-cyan-500 mx-6 "
                : " mx-6 py-3 hover:text-cyan-500"
            }
          >
            About
          </NavLink>
          <NavLink
            to={"/deals"}
            className={({ isActive }) =>
              isActive
                ? "border-t-2 py-3  text-cyan-500 mx-6"
                : " mx-6 py-3  hover:text-cyan-500"
            }
          >
            Deals
          </NavLink>
          <NavLink
            to={"/reservation"}
            className={({ isActive }) =>
              isActive
                ? "border-t-2 py-3  text-cyan-500 mx-6"
                : " mx-6 py-3 hover:text-cyan-500"
            }
          >
            Reservation
          </NavLink>
          <NavLink
            to={"/book-yours"}
            className={({ isActive }) =>
              isActive
                ? "border-t-2 py-3  text-cyan-500 mx-6 "
                : " mx-6 py-3  hover:text-cyan-500"
            }
          >
            Book Yours
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
